import { inject, Injectable } from "@angular/core";
import { BaseWorkflowStateService } from "../base-workflow-state.service";
import { MobileBusinessAgreementData } from "../../../../../../models/order/workflow/wireless/wireless-flow.model";
import { WirelessFlowStateService } from "./wireless-flow-state.service";

@Injectable({ providedIn: 'root' })
export class MobileBusinessAgreementStateService extends BaseWorkflowStateService<MobileBusinessAgreementData> {
    private flowStateService = inject(WirelessFlowStateService);
    override stateKey: string = 'mobileBusinessAgreement';

    protected override saveLocalDraft(): void {
        this.flowStateService.updateData({ mobileBusinessAgreement: this.state() });
    }

    resetData() {
        this.state.set(null);
        this.saveLocalDraft();
    }
}
